import React from 'react';
import InputMask from 'react-input-mask';

interface IProps {
  /** Masked display value, e.g. "(555) 123-____" */
  value: string;
  /** Called on every change with (maskedValue, digitsOnly) */
  onChange: (maskedValue: string, digits: string) => void;
  placeholder?: string;
  className?: string;
}

/** Returns only digits from a masked phone string. */
export function phoneDigits(masked: string): string {
  return masked.replace(/\D/g, '');
}

export default function PhoneMaskInput({ value, onChange, placeholder, className }: IProps) {
  return (
    <InputMask
      mask="(999) 999-9999"
      value={value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const masked = e.target.value;
        onChange(masked, phoneDigits(masked));
      }}
      placeholder={placeholder ?? '(__) ___-____'}
      className={className}
    />
  );
}
